module.exports = __webpack_public_path__ + "b4138f9b2222cc5d42f8e16c04ca30b4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/hawaiian-beach-hut-empty.png
// module id = 322
// module chunks = 0